import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../stores/Hooks';

export const ModalMessageShowComponent: React.FC<any> = observer(
	() =>
	{
		const { uiState } = useStores();
		const store = uiState.modal;

		return (
			<>
				<div className="modal-content">
					<store.RenderComponent />
				</div>
				<div className="modal-footer">
					<div className="d-flex align-items-center">
						<button
							className="btn btn-primary ml-auto"
							onClick={() => { uiState.modal.setShowModal(false); }}
						>Продолжить</button>
					</div>
				</div>
			</>
		);
	}
)
